import mdcHeadline1 from './mdc-headline1.vue'
import mdcHeadline2 from './mdc-headline2.vue'
import mdcHeadline3 from './mdc-headline3.vue'
import mdcHeadline4 from './mdc-headline4.vue'
import mdcHeadline5 from './mdc-headline5.vue'
import mdcHeadline6 from './mdc-headline6.vue'
import mdcSubtitle1 from './mdc-subtitle1.vue'
import mdcSubtitle2 from './mdc-subtitle2.vue'
import mdcBody1 from './mdc-body1.vue'
import mdcBody2 from './mdc-body2.vue'
import mdcCaption from './mdc-caption.vue'
import mdcOverline from './mdc-overline.vue'
import mdcTypoButton from './mdc-typo-button.vue'

export const mdcTypographyComponents = {
  mdcHeadline1,
  mdcHeadline2,
  mdcHeadline3,
  mdcHeadline4,
  mdcHeadline5,
  mdcHeadline6,
  mdcSubtitle1,
  mdcSubtitle2,
  mdcBody1,
  mdcBody2,
  mdcCaption,
  mdcTypoButton,
  mdcOverline,
}